import { connect } from 'react-redux';
import Actions from 'actions/Actions';

const { showGameInfoModal } = Actions;

export default connect(null, {
    showGameInfoModal
});
